import { observerEpicHelper } from 'epics/helpers'
import { Constants } from 'actions/shared/dataLayer'
export const updateDataLayerEpic = observerEpicHelper(
  [Constants.UPDATE_DATALAYER],
  async ({ action, observer, store }): Promise<void> => {
    window.dataLayer.push(action.payload)
    observer.complete()
  }
)
export default [updateDataLayerEpic]